import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-welcome-splash',
  standalone: true,
  imports: [NgClass],
  templateUrl: './welcome-splash.component.html',
  styleUrl: './welcome-splash.component.scss',
})
export class WelcomeSplashComponent {
  @Input() visible = false;
  @Input() logoSrc = 'assets/images/logo1.png';

  // 👇 aqui mandas: "BUENOS DIAS, ADRIAN"
  @Input() subtitle = '';

  // 👇 NUEVO: fecha/hora chiquita (ej: "MIERCOLES 15 ENE 2026 · 14:32")
  @Input() metaText = '';
}
